import {
  Grid,
  Box,
  Typography,
  List,
  ListItemText,
  Button,
} from "@mui/material";
import React from "react";
import { SubscribeTf, FooterTitle } from "../../styles/footer";
import { Colors } from "../../styles/theme";
import { Facebook, Twitter, Instagram } from "@mui/icons-material";
import { Stack } from "@mui/system";
import SendIcon from "@mui/icons-material/Send";
import About from "../Pages/About";
import { Link } from "react-router-dom";
import { useUIContext } from "../../context/ui";
import { useUser } from "../../context/user";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import {
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
} from "react-share";

export default function Footer() {

  const { setShowCart, setShowCheckout } = useUIContext();
  const{user} = useUser()

  return (
    <Box
      sx={{
        background: Colors.primary,
        color: Colors.light_gray,
        padding: { xs: 4, md: 10 },
        pt: 12,
        pb: 12,
        fontSize: { xs: "12px", md: "14px" },
      }}
    >
      <Grid container spacing={2} justifyContent="center">
        <Grid item md={6} lg={4}>
          <FooterTitle variant="body1">About us</FooterTitle>
          <Typography variant="caption2">
            Hello info about us , contact us and tell us what do you thing about
            our services.
          </Typography>
          <Box sx={{ mt: 4, color: Colors.dove_gray }}>
            <Typography variant="caption2">Share this page:</Typography>
            <FacebookShareButton url={window.location.href}>
              <FacebookIcon size={24} round />
            </FacebookShareButton>
            <TwitterShareButton url={window.location.href}>
              <TwitterIcon size={24} round />
            </TwitterShareButton>
            <WhatsappShareButton url={window.location.href}>
              <WhatsappIcon size={24} round />
            </WhatsappShareButton>
          </Box>
        </Grid>
        <Grid item md={6} lg={2}>
          <FooterTitle variant="body1"> Information </FooterTitle>
          <List>
            <ListItemText onClick={() => <About />}>
              <Link
                to="/about"
                component={About}
                style={{ textDecoration: "none", color: Colors.light_gray}}
              >
                <Typography lineHeight={2} variant="caption2">
                  About Us
                </Typography>
              </Link>
            </ListItemText>
            <ListItemText onClick={() => setShowCart(true)}>
              <Typography lineHeight={2} variant="caption2" style={{cursor: 'pointer'}}>
                Order Tracking
              </Typography>
            </ListItemText>
            <ListItemText>
              <Typography lineHeight={2} variant="caption2">
                Terms &amp; Conditions
              </Typography>
            </ListItemText>
          </List>
        </Grid>
        <Grid item md={6} lg={2}>
          <FooterTitle variant="body1"> My account </FooterTitle>
          <List>
            <ListItemText>
              <Typography >
              {user && <Typography lineHeight={2} variant="caption2" color={Colors.light_gray}> {user.displayName} </Typography>}
              </Typography>
            </ListItemText>
            <ListItemText onClick={() => setShowCart(true)}>
              <Typography lineHeight={2} variant="caption2" style={{cursor: 'pointer'}}>
                My cart
              </Typography>
            </ListItemText>
            <ListItemText onClick={() => setShowCheckout(true)}>
              <Typography lineHeight={2} variant="caption2" style={{cursor: 'pointer'}}>
                Checkout
              </Typography>
            </ListItemText>
          </List>
        </Grid>
        <Grid item md={6} lg={4}>
          <FooterTitle variant="body1"> NewsLetter </FooterTitle>
          <Stack>
            <SubscribeTf
              color="primary"
              label="Email address"
              variant="standard"
            />
            <Button
              startIcon={<SendIcon sx={{ color: Colors.white }} />}
              sx={{ mt: 4, mb: 4 }}
              variant="contained"
            >
              Subscribe
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}
